/**
 * P9-P2D — Direction-aware sonner Toaster.
 *
 * Toasts anchor to the inline-end top corner: top-right in LTR (unchanged) and
 * top-left in RTL, so they don't cover the (now right-aligned) primary actions.
 * Passes `dir` to sonner so internal toast layout (icon/close) mirrors too.
 */
import React from 'react';
import { Toaster } from 'sonner';
import { useDirection } from '../../i18n/direction';

export function DirectionalToaster(props) {
  const { dir } = useDirection();
  const position = dir === 'rtl' ? 'top-left' : 'top-right';
  return <Toaster position={position} dir={dir} {...props} />;
}

export default DirectionalToaster;
